export interface TrackPoint {
  x: number
  y: number
}

export interface TrackBounds {
  width: number
  height: number
}

const clamp = (value: number, minimum: number, maximum: number) =>
  Math.min(maximum, Math.max(minimum, value))

const format = (value: number) => Number(value.toFixed(2))

export function getLifecycleStageFractions(stageCount: number): number[] {
  if (stageCount <= 1) return [0]
  return Array.from({ length: stageCount }, (_, index) => index / (stageCount - 1))
}

export function createLifecycleTrackPath(width: number, height: number): string {
  const safeWidth = Math.max(width, 1)
  const safeHeight = Math.max(height, 1)
  const point = (x: number, y: number) =>
    `${format(clamp(x, 0, safeWidth))} ${format(clamp(y, 0, safeHeight))}`

  if (safeWidth < 620) {
    return [
      `M ${point(safeWidth * 0.34, safeHeight * 0.08)}`,
      `C ${point(safeWidth * 0.76, safeHeight * 0.12)} ${point(safeWidth * 0.16, safeHeight * 0.23)} ${point(safeWidth * 0.63, safeHeight * 0.32)}`,
      `S ${point(safeWidth * 0.79, safeHeight * 0.47)} ${point(safeWidth * 0.35, safeHeight * 0.56)}`,
      `S ${point(safeWidth * 0.16, safeHeight * 0.68)} ${point(safeWidth * 0.66, safeHeight * 0.75)}`,
      `S ${point(safeWidth * 0.79, safeHeight * 0.83)} ${point(safeWidth * 0.43, safeHeight * 0.87)}`,
    ].join(' ')
  }

  return [
    `M ${point(safeWidth * 0.06, safeHeight * 0.3)}`,
    `C ${point(safeWidth * 0.18, safeHeight * 0.07)} ${point(safeWidth * 0.28, safeHeight * 0.59)} ${point(safeWidth * 0.41, safeHeight * 0.31)}`,
    `S ${point(safeWidth * 0.62, safeHeight * 0.07)} ${point(safeWidth * 0.72, safeHeight * 0.3)}`,
    `S ${point(safeWidth * 0.86, safeHeight * 0.56)} ${point(safeWidth * 0.94, safeHeight * 0.3)}`,
  ].join(' ')
}

export function getLifecycleStageIndex(progress: number, stageCount: number): number {
  if (stageCount <= 1) return 0
  return Math.round(clamp(progress, 0, 1) * (stageCount - 1))
}

export function findNearestLifecycleStage(
  point: TrackPoint,
  stages: readonly TrackPoint[],
): number {
  let nearestIndex = 0
  let nearestDistance = Number.POSITIVE_INFINITY

  stages.forEach((stage, index) => {
    const distance = Math.hypot(point.x - stage.x, point.y - stage.y)
    if (distance < nearestDistance) {
      nearestDistance = distance
      nearestIndex = index
    }
  })

  return nearestIndex
}
